import React from "react";

const SortIcon = () => (
  <svg
    className="w-6 h-6"
    fill="#ACC659"
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg"
    style={{ height: 32, width: 32 }}
  >
    <path
      fillRule="evenodd"
      d="M3 5a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 10a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 15a1 1 0 011-1h6a1 1 0 110 2H4a1 1 0 01-1-1z"
      clipRule="evenodd"
    ></path>
  </svg>
);

export default SortIcon;
